/*
  Blog round-up kit (loaded by snippets/article-content only when a post uses it).
  Design: Claude Design canvas "Blog Round-up Kit". Styles: blog-native.css.

  1. Buy boxes (snippets/article-buybox): scent switch, and Add to basket via
     /cart/add.js + the Opus Cart drawer (the form still posts to /cart/add if
     anything fails). Express buttons are Shopify's own, one per option.
  2. Comparison table ([data-mb-roundup]): sortable columns (chip labels come from the
     headers: Price, Per 100ml, Per 10ml), from the headers on desktop and from
     sort chips on phones (one table, restyled).
     UK (£) rows always sort ahead of US ($) rows; rows without a value go last.
  3. Scent quiz ([data-mb-quiz]): one question at a time, scored against the
     crawlable scent guide in the post ([data-mb-cand] list items), so the quiz
     can only recommend scents the post itself describes.
  4. Tracking: dataLayer events and Shopify customer events (mb_*).

  Everything is progressive: without JavaScript the table reads in list order,
  the quiz form jumps to the scent guide and Add to basket posts the form.
*/
(function () {
  'use strict';
  var doc = document;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };
  var TICK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';

  /* ── Tracking ─────────────────────────────────────────────── */
  function track(name, data) {
    data = data || {};
    data.post = location.pathname;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'mb_' + name }, data));
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('mb_' + name, data);
      }
    } catch (e) {}
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* ── Buy boxes ────────────────────────────────────────────── */
  function selectOption(box, key, focus) {
    var opts = $$('[data-mb-opt]', box);
    var target = opts.filter(function (o) { return o.getAttribute('data-mb-opt') === key; })[0];
    if (!target) return false;
    opts.forEach(function (o) { o.hidden = o !== target; });
    $$('.mb-buy__scent', target).forEach(function (b) {
      var on = b.getAttribute('data-mb-pick') === key;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on && focus) b.focus();
    });
    return true;
  }
  function selectEverywhere(key) {
    $$('[data-mb-buybox]').forEach(function (box) { selectOption(box, key, false); });
  }

  $$('[data-mb-buybox]').forEach(function (box) {
    box.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-mb-pick]');
      if (!pick) return;
      var key = pick.getAttribute('data-mb-pick');
      selectOption(box, key, true);
      track('buybox_scent', { box: box.id, scent: key });
    });
    box.addEventListener('keydown', function (e) {
      var pick = e.target.closest('.mb-buy__scent');
      if (!pick || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
      e.preventDefault();
      var group = $$('.mb-buy__scent', pick.parentNode);
      var i = group.indexOf(pick) + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1);
      var next = group[(i + group.length) % group.length];
      selectOption(box, next.getAttribute('data-mb-pick'), true);
    });

    $$('form', box).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('.mb-buy__atc');
        var idInput = form.querySelector('[name="id"]');
        if (!btn || !idInput || !window.fetch) return; // plain form post
        e.preventDefault();
        var idle = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        track('buybox_atc', { item: btn.getAttribute('data-mb-item'), scent: btn.getAttribute('data-mb-variant') });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] })
        })
          .then(function (res) {
            return res.json().then(function (body) {
              if (!res.ok) throw new Error(body.description || body.message || 'Could not add to basket');
              return body;
            });
          })
          .then(function () {
            btn.disabled = false;
            btn.innerHTML = TICK + 'Added to basket';
            btn.classList.add('is-added');
            ['cart:refresh', 'cart:updated', 'cart:add'].forEach(function (n) {
              doc.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { source: 'mb-buybox' } }));
            });
            if (typeof window.opusRefreshCart === 'function') { try { window.opusRefreshCart(); } catch (err) {} }
            if (typeof window.opusOpen === 'function') { try { window.opusOpen(); } catch (err) {} }
            setTimeout(function () { btn.innerHTML = idle; btn.classList.remove('is-added'); }, 3500);
          })
          .catch(function (err) {
            if (window.console) console.error('[mb-buybox]', err);
            btn.disabled = false;
            btn.innerHTML = idle;
            form.submit();
          });
      });
    });
  });

  /* ── Outbound links, and links that preselect a scent ─────── */
  doc.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mb-out]');
    if (a) track('outbound', { item: a.getAttribute('data-mb-out'), url: a.href });
    var sel = e.target.closest('[data-mb-select]');
    if (sel && !sel.closest('[data-mb-quiz-result]')) {
      selectEverywhere(sel.getAttribute('data-mb-select'));
      track('pick_click', { scent: sel.getAttribute('data-mb-select'), target: sel.getAttribute('href') });
    }
  });

  /* ── Comparison table ─────────────────────────────────────── */
  $$('[data-mb-roundup]').forEach(function (wrap) {
    var table = wrap.querySelector('table');
    var tbody = table && table.tBodies[0];
    if (!tbody) return;
    var rows = $$('tr', tbody);
    rows.forEach(function (r, i) { r.setAttribute('data-mb-order', i); });
    var heads = $$('th[data-mb-sort]', table);
    // Chip labels come from the column headers ("Per 100ml", "Per 10ml"...).
    var chipDefs = [['list', 'Our list']].concat(heads.map(function (h) {
      return [h.getAttribute('data-mb-sort'), h.textContent.trim()];
    }));
    var state = { key: 'list', dir: 'none' };

    function apply(key, dir, source) {
      state = { key: dir === 'none' ? 'list' : key, dir: dir };
      heads.forEach(function (h) { h.setAttribute('aria-sort', h.getAttribute('data-mb-sort') === state.key ? dir : 'none'); });
      chipDefs.forEach(function (d) { table.classList.remove('is-sort-' + d[0]); });
      if (state.key !== 'list') table.classList.add('is-sort-' + state.key);
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-key') === state.key ? 'true' : 'false'); });
      var sorted = rows.slice().sort(function (a, b) {
        var ao = +a.getAttribute('data-mb-order'), bo = +b.getAttribute('data-mb-order');
        if (state.key === 'list') return ao - bo;
        var av = parseFloat(a.getAttribute('data-' + state.key));
        var bv = parseFloat(b.getAttribute('data-' + state.key));
        var ag = isNaN(av) ? 2 : (a.getAttribute('data-cur') === 'usd' ? 1 : 0);
        var bg = isNaN(bv) ? 2 : (b.getAttribute('data-cur') === 'usd' ? 1 : 0);
        if (ag !== bg) return ag - bg; // £ first, then $, then no value
        if (ag === 2) return ao - bo;
        return (dir === 'descending' ? bv - av : av - bv) || ao - bo;
      });
      sorted.forEach(function (r) { tbody.appendChild(r); });
      if (source) track('table_sort', { column: state.key, direction: dir, from: source });
    }

    heads.forEach(function (th) {
      var btn = doc.createElement('button');
      btn.type = 'button';
      btn.className = 'mb-rt__sort';
      btn.innerHTML = th.innerHTML + '<span class="mb-rt__arrow" aria-hidden="true"></span>';
      th.innerHTML = '';
      th.appendChild(btn);
      th.setAttribute('aria-sort', 'none');
      btn.addEventListener('click', function () {
        var key = th.getAttribute('data-mb-sort');
        var was = state.key === key ? state.dir : 'none';
        apply(key, was === 'ascending' ? 'descending' : was === 'descending' ? 'none' : 'ascending', 'header');
      });
    });

    // Phones: the header row is hidden, so sorting moves to chips above the list.
    var bar = doc.createElement('div');
    bar.className = 'mb-rt__chips';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Sort the list');
    bar.innerHTML = '<span class="mb-rt__chips-label">Sort</span>' +
      chipDefs.map(function (d) {
        return '<button type="button" class="mb-rt__chip" data-key="' + d[0] + '" aria-pressed="' + (d[0] === 'list') + '">' + d[1] + '</button>';
      }).join('');
    wrap.insertBefore(bar, table);
    var chips = $$('.mb-rt__chip', bar);
    bar.addEventListener('click', function (e) {
      var c = e.target.closest('.mb-rt__chip');
      if (!c) return;
      var key = c.getAttribute('data-key');
      apply(key, key === 'list' ? 'none' : 'ascending', 'chip');
    });
  });

  /* ── Scent quiz ───────────────────────────────────────────── */
  $$('[data-mb-quiz]').forEach(function (quiz) {
    var form = quiz.querySelector('[data-mb-quiz-form]');
    var result = quiz.querySelector('[data-mb-quiz-result]');
    var steps = form ? $$('fieldset', form) : [];
    if (!form || !result || !steps.length) return;

    var cands = $$('[data-mb-cand]').map(function (li) {
      var fam = {};
      (li.getAttribute('data-mb-fam') || '').split(',').forEach(function (pair) {
        var bits = pair.split(':');
        if (bits[0]) fam[bits[0].trim()] = parseFloat(bits[1]) || 1;
      });
      var strong = li.querySelector('strong');
      var name = strong ? strong.textContent.trim() : li.textContent.trim();
      var notes = li.textContent.replace(name, '').replace(/^[\s:–-]+/, '').trim();
      return {
        id: li.getAttribute('data-mb-cand'),
        name: name,
        notes: notes,
        fam: fam,
        sw: li.getAttribute('data-mb-sw') || '#D9D8D6',
        link: li.getAttribute('data-mb-link') || '#',
        buy: li.getAttribute('data-mb-buykey') || '',
        buyHref: li.getAttribute('data-mb-buyhref') || li.getAttribute('data-mb-link') || '#',
        kitHref: li.getAttribute('data-mb-kithref') || ''
      };
    });
    if (!cands.length) return;

    quiz.classList.add('is-js');
    var current = 0;
    var started = false;
    var top = doc.createElement('div');
    top.className = 'mb-quiz__top';
    top.innerHTML = '<div class="mb-quiz__bar" aria-hidden="true">' + steps.map(function () { return '<span></span>'; }).join('') +
      '</div><span class="mb-quiz__count" aria-live="polite"></span>';
    form.insertBefore(top, form.firstChild);
    var segs = $$('.mb-quiz__bar span', top);
    var count = top.querySelector('.mb-quiz__count');
    var back = doc.createElement('button');
    back.type = 'button';
    back.className = 'mb-quiz__back';
    back.textContent = 'Back';
    form.appendChild(back);

    function show(i) {
      current = i;
      steps.forEach(function (s, n) { s.hidden = n !== i; });
      segs.forEach(function (s, n) { s.classList.toggle('is-on', n <= i); });
      count.textContent = (i + 1) + ' / ' + steps.length;
      back.hidden = i === 0;
      quiz.classList.toggle('is-past-first', i > 0);
    }
    back.addEventListener('click', function () {
      if (current > 0) show(current - 1);
      var first = steps[current].querySelector('input:checked') || steps[current].querySelector('input');
      if (first) first.focus();
    });

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      if (!started) { started = true; track('quiz_start', {}); }
      var i = steps.indexOf(e.target.closest('fieldset'));
      setTimeout(function () {
        if (i < steps.length - 1) {
          show(i + 1);
          var first = steps[i + 1].querySelector('input:checked') || steps[i + 1].querySelector('input');
          if (first) first.focus();
        } else {
          finish();
        }
      }, 220);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); finish(); });

    function answer(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : '';
    }
    function boxOpt(href, key) {
      var box = href && href.charAt(0) === '#' ? doc.getElementById(href.slice(1)) : null;
      return box && box.querySelector('[data-mb-opt="' + key + '"]');
    }
    function priceIn(opt) {
      var el = opt && opt.querySelector('.mb-buy__now');
      return el ? el.textContent.trim() : '';
    }

    function rank(fam) {
      return cands.map(function (c, i) {
        var s = 0;
        Object.keys(c.fam).forEach(function (f) { s += (fam[f] || 0) * c.fam[f]; });
        return { c: c, s: s, i: i };
      }).sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    }
    function showResult(html) {
      result.innerHTML = html;
      result.hidden = false;
      form.hidden = true;
      quiz.classList.add('is-past-first');
      result.focus();
    }

    /* Oils (data-mb-quiz="oils"): every family has one of our four oils, so the match
       is always ours; the other oils on the list with that kind of scent follow, and
       the budget answer can add a note (from a hidden [data-mb-aside="…"] block in the post). */
    function finishOils() {
      var place = answer('place'), drink = answer('drink'), strength = answer('strength'), budget = answer('budget');
      var fam = { warm: 0, forest: 0, citrus: 0, sweet: 0 };
      if (fam.hasOwnProperty(place)) fam[place] += 2;
      if (fam.hasOwnProperty(drink)) fam[drink] += 2;
      if (strength === 'subtle') fam.citrus += 1;
      if (strength === 'allday') fam.warm += 1;
      var scored = rank(fam);
      var oursRanked = scored.filter(function (x) { return x.c.buy; });
      if (!oursRanked.length) return;
      var topC = oursRanked[0].c;
      var seen = {};
      var also = [];
      scored.forEach(function (x) {
        if (also.length >= 2 || x.c.buy || x.s <= 0 || seen[x.c.link]) return;
        seen[x.c.link] = true;
        also.push(x.c);
      });
      var short = topC.name.replace(/^Mission Beard /, '');
      var price = priceIn(boxOpt(topC.buyHref, topC.buy));
      var html = '<p class="mb-quiz__label">Your match</p>' +
        '<div class="mb-quiz__matchrow"><span class="mb-quiz__bigsw" style="background:' + esc(topC.sw) + '"></span>' +
        '<p class="mb-quiz__match">' + esc(short) + '</p></div>';
      if (topC.notes) html += '<p class="mb-quiz__notes">' + esc(topC.notes.charAt(0).toUpperCase() + topC.notes.slice(1)) + '</p>';
      html += '<a class="mb-quiz__btn" href="' + esc(topC.buyHref) + '" data-mb-select="' + esc(topC.buy) + '">Buy ' + esc(short) + (price ? ' · ' + esc(price) : '') + '</a>';
      if (topC.kitHref) {
        var bundleBox = doc.getElementById(topC.kitHref.slice(1));
        var bundlePrice = bundleBox ? priceIn(bundleBox) : '';
        html += '<a class="mb-quiz__link" href="' + esc(topC.kitHref) + '">Or try all four' + (bundlePrice ? ' · ' + esc(bundlePrice) : '') + '</a>';
      }
      var aside = quiz.querySelector('[data-mb-aside="' + budget + '"]');
      if (aside) html += '<div class="mb-quiz__budget">' + aside.innerHTML + '</div>';
      if (also.length) {
        html += '<p class="mb-quiz__also">Also worth a sniff: ' + also.map(function (c) {
          return '<a href="' + esc(c.link) + '">' + esc(c.name) + '</a>';
        }).join(' or ') + '.</p>';
      }
      html += '<button type="button" class="mb-quiz__restart" data-mb-quiz-restart>Start again</button>';
      selectEverywhere(topC.buy);
      showResult(html);
      var topFam = Object.keys(fam).sort(function (a, b) { return fam[b] - fam[a]; })[0];
      track('quiz_complete', { match: topC.id, family: topFam, strength: strength, budget: budget });
    }

    function finish() {
      if (quiz.getAttribute('data-mb-quiz') === 'oils') { finishOils(); return; }
      var place = answer('place'), drink = answer('drink'), oil = answer('oil'), kit = answer('kit');
      var fam = { warm: 0, woody: 0, sweet: 0, fresh: 0, barbershop: 0 };
      if (fam.hasOwnProperty(place)) fam[place] += 2;
      if (fam.hasOwnProperty(drink)) fam[drink] += 2;
      var bonus = {};
      var oilNote = '';
      if (oil === 'underdog') bonus['mb-underdog'] = 6;
      if (oil === 'sandalwood-vanille') bonus['mb-sandalwood-vanille'] = 6;
      if (oil === 'true-north') {
        fam.woody += 1; fam.fresh += 1;
        oilNote = "There's no True North conditioner, so we've matched its sandalwood, pine and mint.";
      }
      if (oil === 'el-presidente') {
        fam.fresh += 1; fam.woody += 1;
        oilNote = "There's no El Presidente conditioner, so we've matched its citrus and cedarwood.";
      }

      var scored = cands.map(function (c, i) {
        var s = 0;
        Object.keys(c.fam).forEach(function (f) { s += (fam[f] || 0) * c.fam[f]; });
        s += bonus[c.id] || 0;
        return { c: c, s: s, i: i };
      }).sort(function (a, b) { return b.s - a.s || a.i - b.i; });

      var topC = scored[0].c;
      var seen = {};
      seen[topC.link] = true;
      var also = [];
      for (var k = 1; k < scored.length && also.length < 2; k++) {
        var c = scored[k].c;
        if (scored[k].s <= 0 || seen[c.link]) continue;
        seen[c.link] = true;
        also.push(c);
      }

      var html = '<p class="mb-quiz__label">Your match</p>' +
        '<div class="mb-quiz__matchrow"><span class="mb-quiz__bigsw" style="background:' + esc(topC.sw) + '"></span>' +
        '<p class="mb-quiz__match">' + esc(topC.name) + '</p></div>';
      if (oilNote) html += '<p class="mb-quiz__notes">' + esc(oilNote) + '</p>';
      else if (topC.notes) html += '<p class="mb-quiz__notes">' + esc(topC.notes.charAt(0).toUpperCase() + topC.notes.slice(1)) + '</p>';

      if (topC.buy) {
        var condOpt = boxOpt(topC.buyHref, topC.buy);
        var kitOpt = topC.kitHref ? boxOpt(topC.kitHref, topC.buy) : null;
        var price = priceIn(condOpt);
        if (kit === 'both' && kitOpt) {
          var kitImg = kitOpt.querySelector('img');
          var kitTitle = kitOpt.querySelector('.mb-buy__title');
          html += '<div class="mb-quiz__kit">' + (kitImg ? '<img src="' + esc(kitImg.currentSrc || kitImg.src) + '" alt="" width="64" height="64">' : '') +
            '<div><strong>' + esc(kitTitle ? kitTitle.textContent.trim() : 'The kit') + '</strong><span>Shampoo + conditioner · ' + esc(priceIn(kitOpt)) + '</span></div></div>';
          html += '<a class="mb-quiz__btn" href="' + esc(topC.kitHref) + '" data-mb-select="' + esc(topC.buy) + '">Get the kit in ' + esc(topC.name.replace(/^Mission Beard /, '').split(' ')[0]) + '</a>';
          html += '<a class="mb-quiz__link" href="' + esc(topC.buyHref) + '" data-mb-select="' + esc(topC.buy) + '">Or just the conditioner' + (price ? ', ' + esc(price) : '') + '</a>';
        } else {
          html += '<a class="mb-quiz__btn" href="' + esc(topC.buyHref) + '" data-mb-select="' + esc(topC.buy) + '">Buy ' + esc(topC.name.replace(/^Mission Beard /, '')) + (price ? ' · ' + esc(price) : '') + '</a>';
          html += '<a class="mb-quiz__link" href="' + esc(topC.link) + '">Read our take</a>';
        }
      } else {
        html += '<a class="mb-quiz__btn is-light" href="' + esc(topC.link) + '">See it in the list</a>';
        if (kit === 'both') {
          html += '<p class="mb-quiz__aside">Want a wash as well? Grave Before Shave and Polished Gentleman sell matching sets, and Bulldog\'s Original does both in one bottle.</p>';
        }
      }
      if (kit === 'budget') {
        html += '<div class="mb-quiz__budget"><b>Budget</b><p class="mb-quiz__aside"><a href="#bulldog">Bulldog\'s Original 2-in-1</a> is about £6. It doesn\'t list its scent notes, so it\'s not in the quiz.</p></div>';
      }
      if (also.length) {
        html += '<p class="mb-quiz__also">Also worth a sniff: ' + also.map(function (c) {
          return '<a href="' + esc(c.link) + '">' + esc(c.name) + '</a>';
        }).join(' or ') + '.</p>';
      }
      html += '<button type="button" class="mb-quiz__restart" data-mb-quiz-restart>Start again</button>';

      if (topC.buy) selectEverywhere(topC.buy);
      result.innerHTML = html;
      result.hidden = false;
      form.hidden = true;
      quiz.classList.add('is-past-first');
      result.focus();
      var topFam = Object.keys(fam).sort(function (a, b) { return fam[b] - fam[a]; })[0];
      track('quiz_complete', { match: topC.id, family: topFam, oil: oil, kit: kit });
    }

    result.addEventListener('click', function (e) {
      var sel = e.target.closest('[data-mb-select]');
      if (sel) {
        selectEverywhere(sel.getAttribute('data-mb-select'));
        track('quiz_click_buy', { scent: sel.getAttribute('data-mb-select'), target: sel.getAttribute('href') });
      }
      if (e.target.closest('[data-mb-quiz-restart]')) {
        form.reset();
        result.hidden = true;
        form.hidden = false;
        show(0);
        steps[0].querySelector('input').focus();
      }
    });

    show(0);
  });
})();
